import { useState } from 'react'
import { Box, Paper } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import { useTranslation } from 'react-i18next'
import NoRecords from 'components/NoRecords'
import { ROWS_PER_PAGE_OPTIONS } from 'constants'

export default function VisitReportList({ rows = [], columns = [], loading }) {
  const { t } = useTranslation()
  const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: ROWS_PER_PAGE_OPTIONS[0] })

  return (
    <Paper elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, overflow: 'hidden' }}>
      <DataGrid
        rows={rows}
        columns={columns}
        getRowId={row => row.id}
        autoHeight
        disableColumnMenu
        loading={loading}
        paginationModel={paginationModel}
        onPaginationModelChange={setPaginationModel}
        pageSizeOptions={ROWS_PER_PAGE_OPTIONS}
        slots={{
          noRowsOverlay: () => (
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', py: 6 }}>
              <NoRecords message={t('No visits found')} />
            </Box>
          ),
        }}
      />
    </Paper>
  )
}
